<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { useAlert } from 'dashboard/composables';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

import { deleteUnofficialCampaign } from '../assets/unofficialCampaigns.service';

const props = defineProps({
  selectedCampaign: {
    type: Object,
    default: null,
  },
});

const emit = defineEmits(['deleted']);

const { t } = useI18n();

const dialogRef = ref(null);
const isDeleting = ref(false);

const campaignLabel = computed(() => {
  if (props.selectedCampaign?.nome) return props.selectedCampaign.nome;
  if (props.selectedCampaign?.id) return `#${props.selectedCampaign.id}`;
  return t('CAMPAIGN.UNOFFICIAL.DELETE.DEFAULT_NAME');
});

const handleDialogConfirm = async () => {
  if (!props.selectedCampaign?.id || isDeleting.value) return;

  isDeleting.value = true;

  try {
    await deleteUnofficialCampaign(props.selectedCampaign.id);
    useAlert(t('CAMPAIGN.UNOFFICIAL.DELETE.SUCCESS_MESSAGE'));
    emit('deleted');
    dialogRef.value?.close();
  } catch (error) {
    useAlert(
      error?.response?.data?.message ||
        error?.message ||
        t('CAMPAIGN.UNOFFICIAL.DELETE.ERROR_MESSAGE')
    );
  } finally {
    isDeleting.value = false;
  }
};

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('CAMPAIGN.UNOFFICIAL.DELETE.TITLE')"
    :description="
      t('CAMPAIGN.UNOFFICIAL.DELETE.DESCRIPTION', { campaign: campaignLabel })
    "
    :confirm-button-label="t('CAMPAIGN.UNOFFICIAL.DELETE.CONFIRM')"
    :is-loading="isDeleting"
    @confirm="handleDialogConfirm"
  />
</template>
